module.exports = __webpack_public_path__ + "img/cass7.12e3a866.jpg";